export const getWishIdToDelete = state => state.deleteWish.wishIdToDelete



// WEBPACK FOOTER //
// ./src/store/deleteWish/selectors.js